"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Sidebar/TitleTooltip.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Tooltip = require('web/components/Tooltip');







const offsets = { right: { left: 8 }, top: { bottom: 8 } }
const TitleTooltip = ({ title, place = 'right', children }) => title
  ? (
      _react2.default.createElement(_Tooltip.HoverTooltip, {
        type: "dark",
        place: place,
        offset: offsets[place],
        content: _react2.default.createElement(_Tooltip.TooltipHint, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 18}},  title ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}

        ,  children 
      )
    )
  : _react2.default.createElement(_react2.default.Fragment, null,  children )

exports. default = TitleTooltip
